var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{attrs:{"multiple":true,"options":_vm.options,"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }